import constants from '@/constants';
import { getCustomerActualPurchase } from '@/models/api/orderConfirmApi';
import { getCouponRightText } from '@/views/couponsList/config.js';
import { isLoginAuthenticated } from './common.js';
import { Bridge } from '@/utils/bridge';
import {
  getNewCustomerPromotions,
  getPromotionInfosByPromotionIds
} from '@/models/api/promotionApi';
const {
  ENCRYPTED_MARKETPLACE_ID,
  formatTimestamp,
  COUPON_SERVICE_PROMOTION_STATUS
} = constants;

const getPromotionInfo = async (promotionId, promotions, token, callBack) => {
  try {
    const { data } = await getPromotionInfosByPromotionIds(promotionId, token);
    const promotionList = data?.miniAppPromotionList.map((item, index) => ({
      id: item.encryptedPromotionId,
      text: item.optimizedShortMerchandisingMessage,
      thresholdAmount: item?.thresholds[0]?.currencyAmount?.amount,
      benefitsAmount: item?.benefits[0]?.fixedAmount?.amount,
      type: promotions[index].type,
      status: promotions[index].status,
      buttonText: getCouponRightText(promotions[index].status),
      termOfValidity: `${formatTimestamp(
        item.startDate,
        'date',
        '/'
      )} - ${formatTimestamp(item.endDate, 'date', '/')}`,
      priceText: item?.benefits[0]?.fixedAmount?.amount
    }));
    callBack(promotionList);
  } catch (error) {
    console.error(error, 'getPromotionInfo---error');
  }
};

const getPromotions = async (callBack, token) => {
  try {
    const promotionsIds = [];
    const { data: PromotionsData } = await getNewCustomerPromotions(
      {
        encryptedMarketplaceId: ENCRYPTED_MARKETPLACE_ID
      },
      token
    );
    const promotions = PromotionsData?.promotions ?? [];
    // filter promotion status
    const eligiblePromotions = promotions.filter(
      promotion => COUPON_SERVICE_PROMOTION_STATUS[promotion.status]
    );
    if (eligiblePromotions.length) {
      eligiblePromotions.forEach(item => {
        promotionsIds.push(item.promotionId);
      });
      await getPromotionInfo(promotionsIds, eligiblePromotions, token, data =>
        callBack(data)
      );
    } else {
      callBack(eligiblePromotions);
    }
  } catch (error) {
    console.error(error, 'getNewCustomerPromotions--error');
  }
};

export const getPromotionList = async callBack => {
  const isLogin = await isLoginAuthenticated(false);
  if (isLogin === false) {
    getPromotions(Promotion => {
      callBack(Promotion);
    });
  } else {
    try {
      const { data } = await getCustomerActualPurchase();
      if (data.hasActualPurchase === false) {
        const { accessToken: token } = await Bridge.callFnVal(
          'getAccessToken',
          {}
        );
        getPromotions(
          Promotion => {
            callBack(Promotion);
          },
          { token }
        );
      }
    } catch (error) {
      console.error('getCustomerActualPurchase--error>>>', error);
    }
  }
};
